import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { RequestService, StoreService, LoggerService, LoaderService, MenuConfigService, LayoutUtilsService, TabCoordinatorService, GoogleMapsLoaderService, MessagingService } from './shared/services';
import { MenuConfig } from './menu.config';
import { environment } from '../environments/environment';
import { interval, Subscription } from "rxjs";
import { ConstantPool } from '@angular/compiler';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AlertEntityDialogComponent } from './shared/components/modals/alert-entity-dialog/alert-entity-dialog.component';
import { FirebaseAuthService } from './shared/services/firebase-auth.service';
import { NotificationService } from './shared/services/notification.service';
import { SignalingService } from './shared/services/signaling.service';
import { NotificationsHandlersService } from './shared/services/notifications-handlers.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { getOrganizationTemplateDisplayName, resolveTemplateAssetSrc } from './shared/constants/template-options';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public subscriptions: Subscription[] = [];
  public showLoader: boolean = false;
  public showError: boolean = true;
  public languageSelected: string = environment.lang;
  private repeatIntervalSeconds: number = 60;
  private dataSeenOnce: boolean = false;
  private messageSeenOnce: boolean = false;
  private idleState = 'Not started.';
  private activityDialog: any = undefined;
  private aliveAppIntervalMinutes: number = environment.aliveAppIntervalMinutes;
  private aliveCheckAppIntervalMinutes: number = environment.aliveCheckAppIntervalMinutes;
  private message;
  protected networkDialog: any = undefined;
  private watchId: number;
  private lastUpdate: number = 0;
  private readonly UPDATE_INTERVAL = 5000; // 5 seconds throttle

  constructor(private menuConfigService: MenuConfigService, private loaderService: LoaderService,
    public snackBar: MatSnackBar, private translate: TranslateService, private requestService: RequestService,
    private logger: LoggerService, private router: Router, private dialog: MatDialog, private layoutUtilsService: LayoutUtilsService,
    private idle: Idle, private notificationsHandlersService: NotificationsHandlersService,
    private storeService: StoreService, private activatedRoute: ActivatedRoute, private route: ActivatedRoute, private firebaseAuthService: FirebaseAuthService, private notificationService: NotificationService, private signalingService: SignalingService, private messagingService: MessagingService, private tabCoordinatorService: TabCoordinatorService, private googleMapsLoader: GoogleMapsLoaderService, private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer, private titleService: Title) {
    this.titleService.setTitle(getOrganizationTemplateDisplayName());
    this.updateFavicon();
    if (localStorage.getItem('languageSelected')) {
      this.languageSelected = localStorage.getItem('languageSelected');
    } else {
      localStorage.setItem('languageSelected', environment.lang)
    }
    this.setLanguage();
    this.getMe();
    this.setIdleIntervals();
    // Load Google Maps if needed
    if (environment.shouldWeUseGoogle) {
      this.googleMapsLoader.loadGoogleMaps().catch(err => {
        console.warn('Google Maps not loaded:', err);
      });
    }
    this.matIconRegistry.addSvgIcon(
      'add_triangle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon/add_triangle.svg')
    );
  }
  // handleTabs() {
  //   if (!window.opener && window.location.pathname !== '/block') {
  //     setTimeout(() => {
  //       if (!this.tabCoordinatorService.isCurrentTabLeader()) {
  //         window.location.href = `/block`;
  //       }
  //     }, 3000); // Small delay to allow leadership resolution
  //   }
  // }
  ngOnInit() {
    this.subscriptions.push(this.requestService.pageOrganization.subscribe((org) => {
      if (org) {
        const settings = this.requestService.getSettings(org);
        this.titleService.setTitle(getOrganizationTemplateDisplayName(org));
        this.updateFavicon(org);
      }
    }));
    // this.handleTabs();
    this.subscriptions.push(
      interval(60 * 60 * 1000).subscribe(() => {
        this.refreshTokenIfNeeded();
      })
    );
    this.subscriptions.push(
      this.requestService.authenticatedUser.subscribe((event: boolean) => {
        if (event) {
          // let rememberMe = false;
          // if (localStorage.getItem('rememberMe')) {
          //   rememberMe = JSON.parse(localStorage.getItem('rememberMe') || '');
          // }
          // if (!rememberMe) {
          //   this.resetActivity();
          // } else {
          //   this.idle.stop();
          //   console.log('Idle Activity Cancelled');
          // }
          // this.startLocationTracking();
          if (!this.dataSeenOnce) {
            this.getMe();
          }
        } else {
          // this.stopLocationTracking();
          this.idle.stop();
          this.signalingService.close();
        }
      }
      ));
    // this.subscriptions.push(
    //   this.firebaseAuthService.user$.subscribe((status) => {
    //     console.log('status', status);
    //   }));

    // this.subscriptions.push(interval(1000 * this.repeatIntervalSeconds).subscribe(() => {
    //   if (this.requestService.authenticatedUser.getValue()) {
    //     if (!this.requestService.validateMe()) {
    //       // window.location.reload();
    //     }
    //   }
    // }));

    this.subscriptions.push(
      this.requestService.appStatusSubject.subscribe((data: any) => {
        if (data) {
          if (data === 'login') {
            this.notificationsHandlersService.logout(true);
          }
        }
      })
    );
    this.subscriptions.push(
      this.router.events.subscribe((event: any) => {

        if (event instanceof NavigationStart) {
          // Show loading indicator
          this.loaderService.display(false);
        }

        if (event instanceof NavigationEnd) {
          // Hide loading indicator
        }

        if (event instanceof NavigationError) {
          const name = event?.error?.name || '';
          const message = event?.error?.message || event?.error?.toString() || '';
          const isChunkError = name === 'ChunkLoadError' || /Loading chunk|ChunkLoadError|dynamic import|import\(\)/i.test(message);
          if (isChunkError) {
            this.openAlert(this.translate.instant('A new version is available. Please refresh.', this.translate.instant('Alert')));
            return;
          }
          console.log('NavigationError:', event.error);
        }
      })
    );
    this.subscriptions.push(
      this.logger.errorObject.subscribe((error) => {
        if (error) {
          // console.log('Global Error: ', error);
          // this.loaderService.display(false);
          if (this.showError) {
            this.showError = false;
            this.openAlert('An Error occured:' + error);
          }
        }
      })
    );
    this.menuConfigService.loadConfigs(new MenuConfig().configs);

    this.subscriptions.push(
      this.requestService.currentUserSubject.subscribe((data) => {
        if (data) {
          // this.ablyService.init();
        }
      }));
    this.subscribeActivity();
  }
  ngOnDestroy() {
    this.signalingService.close();
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
  setLanguage() {
    this.translate.setDefaultLang(this.languageSelected);
    this.translate.use(this.languageSelected);
  }
  getQueryParam(param) {
    var result = window.location.href.match(
      new RegExp("(\\?|&)" + param + "(\\[\\])?=([^&]*)")
    );

    return result ? result[3] : false;
  }
  public getMe() {
    // let urlToken = this.getQueryParam('token');//this.route.snapshot.queryParams['token'] || '';
    if (localStorage.getItem('o') && localStorage.getItem('a') && localStorage.getItem('l') && localStorage.getItem('org')) {
      let orgId = JSON.parse(localStorage.getItem('o'));
      let appId = JSON.parse(localStorage.getItem('a'));
      let locId = JSON.parse(localStorage.getItem('l'));
      let orgData = JSON.parse(localStorage.getItem('org'));

      const pinnedCodeVersion = (localStorage.getItem('civix-code-version') || '').trim();
      if (pinnedCodeVersion && orgData && typeof orgData === 'object') {
        orgData = {
          ...orgData,
          settings: {
            ...(orgData.settings || {}),
            codeVersion: pinnedCodeVersion,
          },
        };
      }
      this.requestService.orgId = orgId;
      this.requestService.appId = appId;
      this.requestService.locId = locId;
      this.requestService.pageOrganization.next(orgData);

      this.messagingService.setOrgId(orgId);
      if (localStorage.getItem('currentUser')) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.requestService.currentUser = currentUser;
        let resource = this.requestService.getItemFromListContains(currentUser.resources, orgId, 'organizationId');
        if (resource) {
          this.requestService.updatePermissions(resource._id);
          this.dataSeenOnce = true;
          this.validateMeByApi();
        }
      }
    } else {
      this.dataSeenOnce = false;
    };
  }
  public validateMeByApi() {
    this.requestService.getMe((data, error) => {
      if (error) {
        // this.requestService.logout();
        //console.log(error);
      }
      if (data) {
        this.notificationService.dnd.next(data.dnd || false);
        sessionStorage.setItem('live', JSON.stringify(true));
        this.requestService.authenticatedUser.next(true);
        this.refreshOrganizationFromApi();
        // valid
      } else {
        this.dataSeenOnce = false;
        // this.requestService.logout();
      }
    });
  }

  private refreshOrganizationFromApi(): void {
    const orgId = this.requestService.orgId;
    if (!orgId) {
      return;
    }
    this.requestService.getSingleCachData('organization', orgId, (orgData, orgErr) => {
      if (orgErr || !orgData) {
        return;
      }
      try {
        localStorage.setItem('org', JSON.stringify(orgData));
      } catch (e) {
        console.warn('Could not persist refreshed organization to localStorage', e);
      }
      this.requestService.pageOrganization.next(orgData);

      const cv = orgData?.settings?.codeVersion;
      if (cv != null && String(cv).trim() !== '') {
        try {
          localStorage.setItem('civix-code-version', String(cv).trim());
        } catch (e2) {
          console.warn('Could not persist refreshed code version to localStorage', e2);
        }
      }
    }, false);
  }
  public refreshTokenIfNeeded() {
    if (localStorage.getItem('currentUser') && localStorage.getItem('o') && localStorage.getItem('a') && localStorage.getItem('l')) {
      this.requestService.getMe((data, error) => {
        if (error) {
          // not valid
        }
        if (data) {
          // valid
        }
      });
    }
  }
  public openAlert(message, title = 'Error') {
    const _title: string = title;
    const _description: string = message;

    const dialogRef = this.layoutUtilsService.errorElement(_title, _description);
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      window.location.reload();
    });
  }

  setIdleIntervals() {
    if (localStorage.getItem('idleInterval') && localStorage.getItem('timeoutInterval')) {
      this.aliveCheckAppIntervalMinutes = JSON.parse(localStorage.getItem('idleInterval'));
      this.aliveAppIntervalMinutes = JSON.parse(localStorage.getItem('timeoutInterval'));
    } else {
      localStorage.setItem('idleInterval', JSON.stringify(this.aliveCheckAppIntervalMinutes));
      localStorage.setItem('timeoutInterval', JSON.stringify(this.aliveAppIntervalMinutes))
    }
  }

  resetActivity() {
    if (window.location.pathname.indexOf('/location/') == -1 && window.location.pathname.indexOf('/annotate/') == -1) {
      // console.log(window.location.pathname);
      this.idle.watch();
      this.idleState = 'Running.';
      console.log('Idle Activity', this.idleState);
      // }
    }
  }

  subscribeActivity() {
    console.log('Idle Activity initialized');
    this.idle.setIdle(this.aliveCheckAppIntervalMinutes * 60);
    this.idle.setTimeout(this.aliveAppIntervalMinutes * 60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.subscriptions.push(
      this.idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No longer idle.'
        console.log(this.idleState);
        this.resetActivity();
      })
    );
    this.subscriptions.push(
      this.idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        console.log(this.idleState);
        this.dataSeenOnce = false;
        this.activityDialog = undefined;
        // this.requestService.logout();
        this.notificationsHandlersService.logout();
      })
    );
    this.subscriptions.push(
      this.idle.onIdleStart.subscribe(() => {
        this.idleState = 'You\'ve gone idle!'
        console.log(this.idleState);
        this.noActivity(this.translate.instant('No Activity'), this.translate.instant('You have been idle for a long time. Please log in again to continue'));
      })
    );
    this.subscriptions.push(
      this.idle.onTimeoutWarning.subscribe((countdown) => {
        this.idleState = 'You will time out in ' + countdown + ' seconds!'
        console.log(this.idleState);
      })
    );
  }

  noActivity(title: string, msg: string) {
    if (!this.activityDialog) {
      let alertSetting = {};
      alertSetting['overlayClickToClose'] = false;
      alertSetting['showCloseButton'] = false;
      alertSetting['confirmText'] = this.translate.instant('Ok');
      // alertSetting['confirmText'] = this.translate.instant('Yes');
      // alertSetting['declineText'] = this.translate.instant('No');
      // alertSetting['timerEvent'] = 120;

      this.activityDialog = this.layoutUtilsService.alertActionElement(title, msg, alertSetting);
      this.activityDialog.afterClosed().subscribe(res => {
        this.dataSeenOnce = false;
        this.activityDialog = undefined;
        // this.requestService.logout();
        this.notificationsHandlersService.logout();
      });
    }
  };

  @HostListener('window:offline', ['$event'])
  OfflineEvent(event: Event) {
    setTimeout(() => {
      this.requestService.isNetworkConnected = navigator?.onLine;
      if (!navigator?.onLine)
        this.networkDialog = this.showNetworkDisconnectedDialog();
      else
        this.networkDialog = undefined;
    }, 5000);
  }

  @HostListener('window:online', ['$event'])
  OnlineEvent(event: Event) {
    this.requestService.isNetworkConnected = true;
    if (this.networkDialog) {
      window.location.reload();
    }
  }

  private startLocationTracking() {
    if (navigator.geolocation) {
      // Clear existing watch if any
      this.stopLocationTracking();

      this.watchId = navigator.geolocation.watchPosition(
        (position) => {
          const now = Date.now();
          if (now - this.lastUpdate > this.UPDATE_INTERVAL) {
            this.lastUpdate = now;
            this.updatePosition(position.coords);
          }
        },
        (error) => {
          console.error('[App] Error watching position:', error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      console.warn('[App] Geolocation is not supported by this browser.');
    }
  }

  private stopLocationTracking() {
    if (this.watchId !== undefined) {
      navigator.geolocation.clearWatch(this.watchId);
      this.watchId = undefined;
      // Send offline status
      if (this.requestService.currentUser && this.requestService.currentUser._id) {
        this.requestService.updateUserPosition(this.requestService.currentUser._id, {
          active: false,
          position: { lat: 0, lng: 0 }
        }, () => { });
      }
    }
  }

  private updatePosition(coords: GeolocationCoordinates) {
    // console.log('[App] updatePosition called with:', coords.latitude, coords.longitude);
    if (this.requestService.currentUser && this.requestService.currentUser._id) {
      const positionData = {
        lat: coords.latitude,
        lng: coords.longitude,
        active: true
      };

      this.requestService.updateUserPosition(
        this.requestService.currentUser._id,
        positionData,
        (response, error) => {
          if (error) {
            console.error('[App] Failed to update position:', error);
          } else {
            console.log('[App] Position updated successfully. Lat:', coords.latitude, 'Lng:', coords.longitude);
          }
        }
      );
    }
  }

  private showNetworkDisconnectedDialog() {
    if (this.networkDialog)
      this.networkDialog.close();

    this.networkDialog = this.layoutUtilsService.alertActionElement('', this.translate.instant('Network Disconnected'), {
      overlayClickToClose: false,
      showCloseButton: false,
      confirmText: this.translate.instant('Refresh')
    });
    this.networkDialog.afterClosed().subscribe(res => {
      if (res) {
        if (res.action === 'confirmText') {
          window.location.reload();
        }
      }
    });
    return this.networkDialog;
  }

  private updateFavicon(organization?: any): void {
    if (typeof document === 'undefined') {
      return;
    }

    void resolveTemplateAssetSrc('favicon.ico', 'favicon.ico', organization).then((src) => {
      const faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
      if (!faviconLink) {
        return;
      }
      faviconLink.href = src;
    });
  }
}
